import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '首页', to: '/' },
  { label: '分集剧情', to: '/', section: 'episode' },
  { label: '剧情梳理', to: '/', section: 'storyline' },
  { label: '常见问题', to: '/', section: 'faq' },
  { label: '关于我们', to: '/about' },
];

const categoryLinks = ['奇幻冒险', '治愈日常', '武侠古风', '科幻机战', '青春校园', '悬疑推理'];

export default function Footer() {
  return (
    <footer className="bg-background-800 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* brand */}
          <div className="sm:col-span-2 lg:col-span-2">
            <div className="flex items-center gap-2 font-heading text-lg font-bold text-background-50">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-film-fill text-lg" />
              </span>
              羞羞动漫网
            </div>
            <p className="mt-4 max-w-md text-sm leading-6 text-background-300">
              专注分集剧情解说与每话简介的动漫网站。我们把每一部番剧拆解成清晰的故事线，按话整理简介与剧情梳理，帮助你补番、追更、回顾剧情时都能快速抓住走向。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-700/60 px-3 py-1 text-xs text-background-200">
                <i className="ri-check-line text-accent-300" /> 每话简介
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-700/60 px-3 py-1 text-xs text-background-200">
                <i className="ri-check-line text-accent-300" /> 剧情梳理
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-700/60 px-3 py-1 text-xs text-background-200">
                <i className="ri-check-line text-accent-300" /> 故事线解说
              </span>
            </div>
          </div>

          {/* quick links */}
          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((item) => (
                <li key={item.label}>
                  {item.section ? (
                    <a
                      href={`/#${item.section}`}
                      className="text-sm text-background-300 transition-colors hover:text-accent-300"
                    >
                      {item.label}
                    </a>
                  ) : (
                    <Link to={item.to} className="text-sm text-background-300 transition-colors hover:text-accent-300">
                      {item.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* categories */}
          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">热门分类</h3>
            <ul className="mt-4 flex flex-wrap gap-x-4 gap-y-2.5">
              {categoryLinks.map((c) => (
                <li key={c}>
                  <a href="/#episode" className="text-sm text-background-300 transition-colors hover:text-accent-300">
                    {c}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-5">
              <h3 className="font-heading text-sm font-semibold text-background-50">联系方式</h3>
              <a
                href="mailto:contact@xiuxiu-dongman.com"
                className="mt-2 inline-flex items-center gap-2 text-sm text-background-300 transition-colors hover:text-accent-300"
              >
                <i className="ri-mail-line" /> contact@xiuxiu-dongman.com
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-700/60 pt-6 sm:flex-row">
          <p className="text-xs text-background-400">
            © {new Date().getFullYear()} 羞羞动漫网 · 分集剧情解说与每话简介平台
          </p>
          <p className="text-xs text-background-400">本网站内容仅作剧情交流与信息整理之用</p>
        </div>
      </div>
    </footer>
  );
}